import { render, staticRenderFns } from "./DuplicateCustomer.vue?vue&type=template&id=30971dc8&scoped=true"
import script from "./DuplicateCustomer.vue?vue&type=script&lang=ts"
export * from "./DuplicateCustomer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30971dc8",
  null
  
)

export default component.exports